module.exports = __webpack_public_path__ + "static/media/download.62f8ff5d.svg";